export const ADMIN_ORG_ID_KEY = "dotell-admin-orgId-2";
export const ADMIN_USER_TYPE_KEY = "dotell-admin-user-type-2";

export const DEFAULT_DESIGN_SYSTEM = {
  font: "Figtree",
  titleColor: "#121212",
  subtitleColor: "#121212",
  paragraphColor: "#150C1D",
  hyperlinkColor: "#121212",
  highlightColor: "#121212",
  highlightTextColor: "#FFFFFF",
  primaryColor: "#0a2747",
  secondaryColor: "#EEEEEE",
  themeColor3: "#010c17",
  themeColor4: "#0a78d2",
  buttonRadius: "2px",
  titleFont: "Figtree",
  subtitleFont: "Figtree",
  paragraphFont: "Figtree",
  backgroundColor: "#FFFFFF",
  backgroundColor2: "#F8F8F8",
  // ===== BUTTONS =====
  // This object is the seed for "New theme" on the design page and the
  // fallback for every other flow that needs a starting design system. A key
  // missing here is simply absent from the new theme record, so the preview
  // keeps rendering whatever the previewed deck was published with while the
  // panel shows its own fallback — the two disagree, and the user sees a
  // coloured primary button next to an unstyled secondary one.
  //
  // It previously defined 5 of the 16 button keys in
  // DESIGN_SYSTEM_ROOT_MAPPING and no secondary button at all. The secondary
  // slots fell through to SECONDARY_TO_PRIMARY_FALLBACK, which chains them to
  // `var(--button-…)` — so a new design system's secondary button rendered as
  // a duplicate of the primary, minus the border it had no width for.
  //
  // Every value below is derived from a colour already in this object rather
  // than a new one, in the filled-primary / outlined-secondary pairing the
  // product already uses: the primary is a solid fill, the secondary is the
  // page background with the primary's colour as text and border.
  buttonColor: "#FFFFFF",
  buttonHoverColor: "#121212",
  buttonBackgroundColor: "#121212",
  buttonBackgroundHoverColor: "#EEEEEE",
  buttonBorderWidth: "1px",
  // Border matches the fill so a filled button reads as one solid shape.
  buttonBorderColor: "#121212",
  buttonBorderColorHover: "#EEEEEE",
  secondaryButtonColor: "#121212",
  secondaryButtonHoverColor: "#121212",
  secondaryButtonBackgroundColor: "#FFFFFF",
  // Borrowed from the primary's hover fill so the secondary has a visible
  // hover state. Left unset it would derive as white at 70% alpha, which is
  // invisible on a white page.
  secondaryButtonBackgroundHoverColor: "#EEEEEE",
  secondaryButtonBorderWidth: "1px",
  secondaryButtonBorderColor: "#121212",
  secondaryButtonBorderColorHover: "#121212",
  // Kept equal to buttonRadius: the two buttons sit side by side, so a
  // mismatched radius reads as a mistake.
  secondaryButtonRadius: "2px",
  titleStyle: "700",
  titleFontSize: "40px",
  subtitleStyle: "600",
  subtitleFontSize: "32px",
  paragraphStyle: "400",
  paragraphFontSize: "18px",
  mobileTitleFontSize: "34px",
  mobileSubtitleFontSize: "24px",
  mobileParagraphFontSize: "16px",
  hyperlinkHoverColor: "#121212",
  rkpiFontSize: "100%",
  titleMargin: "12px",
  subtitleMargin: "12px",
  paragraphMargin: "12px",
  theme: "storydoc.com (29/09/2025 12:21)",
};
